import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { atom, useRecoilState } from "recoil";
import {
  getLPointShowValue,
  GetMoneyValue,
  getThousandComma,
} from "../../Api/ApiCommon";
import LineBtn from "../../components/Button/LineBtn";
import LineBox from "../../components/DefaultStyles/LineBox";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import { useLocation, useNavigate } from "react-router-dom";
import PayInfoDetail from "../../components/pages/Pay/PayInfo/PayInfoDetail";
import Loader from "../../components/DefaultStyles/Loader";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import PayInfoFilter from "../../components/pages/Pay/PayInfo/PayInfoFilter";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import { TotalCount } from "../Users/UserInfo";
import { PayReason } from "../../Api/Types";
import { getString3ByKey } from "../../AdminApi/3.0_utils";
import Flex from "../../components/DefaultStyles/Flex";
import ToggleBtn from "../../components/Button/ToggleBtn";
import { ChatType } from "../../components/pages/Party/ChatInfo/ChatSearch/RecentChat/RecentChatHeader";

interface IPayFailLog {
  logdata: {
    comm: number;
    money: number;
    point: number;
    amount: number;
    cdname: string;
    charge: number;
    coupon: number;
    deposit: number;
  };
  mcid: string;
}

export interface IPayFilter {
  type: string;
  searchValue: string;
  memo: string;
}

export interface IPay extends IPayFailLog {
  uid: number;
  name: string;
  nickname: string;
  partyid: number;
  servsubsid: number;
  time: string;
  log: {
    comm: number;
    money: number;
    point: number;
    amount: number;
    cdname: string;
    charge: number;
    coupon: number;
    deposit: number;
    fowner: number;
    returnfee: number;
    reward: number;
    bankname: string;
    banknum: string;
    members: {
      uid: number;
      val: number;
      comm: number;
    }[];
    exit_deposit: { uid: string; val: number }[];
    pg?: number;
  };
  type: number;
  mcid: string;
  curmoney: string;
  payday: boolean;
  members: {
    uid: number;
    fowner: number;
  }[];
  pg: string;
}

export const payTypeString = (type: number, isHost?: boolean) => {
  switch (type) {
    case PayReason.Ch_PartyFee: // 1: 파티 요금 결제
    case PayReason.Ch_PartyFee_PayDay: // 2: 파티 요금 결제 (정산일)
    case PayReason.Ch_PartyFee_Before: // 6: 예정 파티 즉시 결제
    return getString3ByKey(20006); // 파티 요금 결제
    case PayReason.Ch_PartyFee_Proxy: // 8: 프록시 파티 결제
      return getString3ByKey(20006) + "_Proxy"; // 파티 요금 결제

    case PayReason.Ch_PenaltyFee: // 3: 파티 위약금 결제
      return getString3ByKey(30232); // 해산 위약금 결제

    case PayReason.Ch_GuaranteeFee: // 4: 파티 보증금 거치
      return "파티 보증금 결제"; // 파티 보증금 결제

    case PayReason.Re_EndRew: // 51: 파티 종료 적립 (정상) - 파티원
      return getString3ByKey(30235); // 파티 보증금 환급

    case PayReason.Re_EndCompensation: // 50: 파티 리워드(종료 리워드, 중도 탈퇴 보상금) 적립 (파티장)
    case PayReason.Re_PartyFee_PayDay: // 53: 파티 요금 적립 (정산일)
    case PayReason.Re_PartyFee_PartyEnd: // 56: 파티 요금 적립 (종료 파티)
      return getString3ByKey(20005); // 파티 요금 적립

    case PayReason.Re_Compensation: // 52: 파티 보상금 적립
      return getString3ByKey(30230); // 탈퇴 보상금 적립

    case PayReason.Re_EndRew_Exit: // 54: 파티 종료 적립 (중도 탈퇴)
      return getString3ByKey(30236); // 파티 종료 적립 (탈퇴)

    case PayReason.Re_PartyFee_PartyEnd_Sset: // 57: 파티 요금 적립 (종료 파티 선셋)
    case PayReason.Re_EndCompensation_Sset: // 62: 파티 리워드(종료 리워드, 중도 탈퇴 보상금) 적립 (일몰) - 파티장
      return getString3ByKey(30233); // 파티 종료 적립 (일몰)

    case PayReason.Re_No_Reason_Exit: // 58: 무책 탈퇴
    case PayReason.Re_1_Exit: // 59: 무책 일할 탈퇴
      return getString3ByKey(30238); // 파티 종료 적립 (무책 탈퇴)

    case PayReason.Re_EndRew_Break: // 55: 파티 종료 적립 (중도 해산)
      return getString3ByKey(30237); // 파티 종료 적립 (해산)

    case PayReason.Re_No_Reason_Broken: // 60: 무책 해산
    case PayReason.Re_1_Broken: // 61: 무책 일할 해산
    return getString3ByKey(30239); // 파티 종료 적립 (무책 해산)
    case PayReason.Re_Youtube_Broken: // 65: 유튜브 일할 환불
    case PayReason.Re_Youtube_Broken_PG: // 66: 유튜브 일할 환불 PG
     return getString3ByKey(30239) + "_Proxy";

    case PayReason.Ch_eat_n_run: // 62: 먹튀
      return getString3ByKey(30232); // 해산 위약금 결제

    case PayReason.Re_EndRew_Before_Exit: // 63: 예정 탈퇴/해산 (즉시 결제)
      return getString3ByKey(30313); // 첫 달 요금 환불

    case PayReason.Re_EndRew_No_Reason_Break: // 64: 파티 종료 적립(무책 일할 해산) 파티장
      return "파티 종료 적립 (무책 일할 해산-파티장)"; // 첫 달 요금 환불

    case PayReason.WithDraw: // 101: 인출
      return getString3ByKey(30173); // 링키드 머니 인출

    case PayReason.Admin_Cut_Money: // 102: 링키드 머니 차감 (어드민)
      return getString3ByKey(30240); // 링키드 머니 차감

    case PayReason.Admin_Charge_Money: // 103: 링키드 머니 충전 (어드민)
      return getString3ByKey(30241); // 링키드 머니 충전

    default:
      return "";
  }
};

export const payInfoPageState = atom<number>({
  key: "payInfoPageState",
  default: 0,
});

export const payInfoIsNewVersionState = atom<boolean>({
  key: "payInfoIsNewVersionState",
  default: true,
});

export default function PayInfo() {
  const location = useLocation();
  const navigate = useNavigate();

  const [savedPage, setSavedPage] = useRecoilState<number>(payInfoPageState);
  const [isNewVersion, setIsNewVersion] = useRecoilState<boolean>(
    payInfoIsNewVersionState,
  );
  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(page);
  }, [page]);
  const [filter, setFilter] = useState({
    type: "",
    searchValue: "",
    memo: "",
  });
  const [btnClick, setBtnClick] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const { response, loading } = useApi({
    method: "get",
    url:
      `${isNewVersion ? "pay/bill" : "pay"}?page=${page}&size=10` +
      (filter?.searchValue ? `&${filter?.type}=${filter?.searchValue}` : ``) +
      (filter?.memo ? `&alias=${filter?.memo}` : ``),
  });

  const tableHead = [
    "UID_이름_닉네임",
    "PID",
    "적요",
    "금액",
    "잔여 링키드 머니",
    "결제 일시",
    "비고",
    "보기",
  ];

  useEffect(() => {
    setTimeout(() => {
      setBtnClick(false);
    }, 100);
  }, [page]);

  useEffect(() => {
    if (location?.state?.isNewVersion != null)
      setIsNewVersion(location?.state?.isNewVersion);
  }, [location?.state?.isNewVersion]);

  return (
    <>
      <PageTitle title="결제/적립/인출 정보" />

      <PayInfoFilter setFilter={setFilter} filter={filter} setPage={setPage} />

      <LineBox>
        <SpaceBetween>
          <div />

          <Flex gapSize={8}>
            <ToggleBtn
              check={isNewVersion}
              checkEvent={() => setIsNewVersion((prev) => !prev)}
            />

            <ChatType isFirebase={!isNewVersion}>
              {isNewVersion ? "버전 3" : "버전 2"}
            </ChatType>
          </Flex>
        </SpaceBetween>

        <Table tableHeadData={tableHead} tableMinWidth={884}>
          <>
            {response?.data?.items?.map((d: IPay, index: number) => {
              return (
                <React.Fragment key={index}>
                  <TableBody>
                    <TableBodyItem
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => {
                        setSavedPage(page);
                        navigate(`/users/info/${d?.uid}`);
                      }}
                    >
                      {d?.uid}_{d?.name}_{d?.nickname}
                    </TableBodyItem>
                    <TableBodyItem
                      style={{
                        textDecoration: d?.partyid ? "underline" : "auto",
                        cursor: d?.partyid ? "pointer" : "auto",
                      }}
                      onClick={() => {
                        if (d?.partyid) {
                          setSavedPage(page);
                          navigate(`/party/info/${d?.partyid}`);
                        }
                      }}
                    >
                      {d?.partyid === 0 ? "-" : d?.partyid}
                    </TableBodyItem>
                    <TableBodyItem>
                      {payTypeString(d?.type, true)}
                    </TableBodyItem>
                    <TableBodyItem style={{ fontWeight: "bold" }}>
                      {GetMoneyValue(
                        d?.type === PayReason.Re_PartyFee_PartyEnd ||
                          d?.type === PayReason.Re_PartyFee_PayDay ||
                          d?.type === PayReason.Re_EndCompensation ||
                          d?.type === PayReason.Re_EndRew_No_Reason_Break ||
                          d?.type === PayReason.Re_EndCompensation_Sset
                          ? d?.log?.amount
                          : d?.log?.amount -
                              (d?.log?.point ?? 0) -
                              (d?.log?.pg ?? 0),
                      )}
                    </TableBodyItem>
                    <TableBodyItem>{GetMoneyValue(d?.curmoney)}</TableBodyItem>
                    <TableBodyItem>
                      {dayjs(d?.time)?.format("YYYY-MM-DD HH:mm")}
                    </TableBodyItem>
                    <TableBodyItem>{d?.payday ? "정산일" : "-"}</TableBodyItem>
                    <TableBodyItem>
                      <LineBtn
                        btnText={
                          activeIndex === index && btnClick ? "접기" : "보기"
                        }
                        btnClickEvent={() => {
                          setActiveIndex(index);

                          if (activeIndex === index) {
                            // 열려있을 때
                            setBtnClick(!btnClick);
                          } else {
                            // 열기
                            setBtnClick(true);
                          }
                        }}
                      />
                    </TableBodyItem>
                  </TableBody>

                  {activeIndex === index && btnClick && (
                    <PayInfoDetail data={d} isNewVersion={isNewVersion} />
                  )}
                </React.Fragment>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0,
            )}
            개
          </TotalCount>
        </SpaceBetween>

        <>{loading && <Loader />}</>
      </LineBox>

      {/* <PayInfoExcelDownload data={response?.data?.items} /> */}
      <ExcelDownload disabled={true} />
    </>
  );
}
